
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, AlertTriangle, Clock } from "lucide-react";

interface AgencyStatusCardProps {
  status: 'on-time' | 'overdue' | 'mixed';
  overdueTasks: number;
  onTimeTasks: number;
  isLoading: boolean;
}

export function AgencyStatusCard({ status, overdueTasks, onTimeTasks, isLoading }: AgencyStatusCardProps) {
  const getStatusConfig = () => {
    switch (status) {
      case 'on-time':
        return {
          icon: CheckCircle,
          text: 'Agência em Dia',
          color: 'text-green-500',
          bgColor: 'bg-green-50',
          description: 'Todas as tarefas estão em dia'
        };
      case 'overdue':
        return {
          icon: AlertTriangle,
          text: 'Agência Atrasada',
          color: 'text-red-500',
          bgColor: 'bg-red-50',
          description: 'Existem tarefas atrasadas'
        };
      case 'mixed':
        return {
          icon: Clock,
          text: 'Atenção Necessária',
          color: 'text-yellow-500',
          bgColor: 'bg-yellow-50',
          description: 'Algumas tarefas estão atrasadas'
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  if (isLoading) {
    return (
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Status da Agência</CardTitle>
          <div className="h-4 w-4 bg-gray-200 animate-pulse rounded" />
        </CardHeader>
        <CardContent>
          <div className="h-8 w-32 bg-gray-200 animate-pulse rounded mb-2" />
          <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={config.bgColor}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Status da Agência</CardTitle>
        <Icon className={`h-4 w-4 ${config.color}`} />
      </CardHeader>
      <CardContent>
        <div className={`text-2xl font-bold ${config.color}`}>
          {config.text}
        </div>
        <p className="text-xs text-muted-foreground mt-1">
          {config.description}
        </p>
        {(overdueTasks > 0 || onTimeTasks > 0) && (
          <div className="flex gap-4 mt-2 text-xs">
            {overdueTasks > 0 && (
              <span className="text-red-600">
                {overdueTasks} atrasada{overdueTasks !== 1 ? 's' : ''}
              </span>
            )}
            {onTimeTasks > 0 && (
              <span className="text-green-600">
                {onTimeTasks} em dia
              </span>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
